<template>
    <div>
        <!-- Personalización -->
        
        <BCard>
          <BForm @submit.prevent>
            <ValidationObserver  #default="{invalid}" >
              <BRow>
                <TextInputValidated class="" vsMd="3" vsName="Nombre de la aplicación" :vsModel.sync="settings.app_name" vsLabel="app_name" /> 
                <TextInputValidated class="" vsMd="3" vsName="Sitio web" vsLabel="email " :vsModel.sync="settings.website"/>
                <TextInputValidated class="" vsMd="3" vsName="Email" vsLabel="name" :vsModel.sync="settings.email"/>
              </BRow>
              <BRow class="mt-2">
                <BCol>
                  <label>Tipo</label>
                </BCol>
                <BFormRadioGroup name="Tipo de empresa"  class="d-flex col-12" v-model="settings.is_company" required>            
                  <BFormRadio  class="pr-1" v-for="i in institutionsOptions" :key="i.text" :value="i.value" >{{ i.text }} </BFormRadio>
                </BFormRadioGroup>
              </BRow> 
        
              <hr>
              <BRow class="mt-2">
                <TextInputValidated vsMd="3" vsName="Business name" :vsModel.sync="settings.company_name" vsLabel="businessName" vsRequired vsRules="required" />
                <TextInputValidated vsMd="3" vsName="CIF" :vsModel.sync="settings.cif" vsLabel="cif" vsRequired vsRules="required"/>
                <TextInputValidated vsMd="3" vsName="Address" :vsModel.sync="settings.address" vsLabel="address" vsRequired vsRules="required"/>
                <TextInputValidated vsMd="3" vsName="Postal code" :vsModel.sync="settings.postal_code" vsLabel="postal_code" vsRequired vsRules="required"/>
                <TextInputValidated vsMd="3" vsName="City" :vsModel.sync="settings.city" vsLabel="city" vsRequired vsRules="required"/>
                <VSelectValidated vsMd="3" vsName="Province" :vsClearable="true" :vsModel.sync="settings.province_id" :vsReduce="province => province.id" :vsOptions="provinces" vsLabel="name" vsRequired vsRules="required"/>
                <VSelectValidated vsMd="3" vsName="Country" :vsClearable="true" :vsModel.sync="settings.country_id" :vsReduce="country => country.id" :vsOptions="countries" vsLabel="name" vsRequired vsRules="required"/>
                <TextInputValidated vsMd="3" vsName="Phone" vsLabel="name" :vsModel.sync="settings.phone"/>
                <TextInputValidated vsMd="3" vsName="VAT intracomunitario" vsLabel="name" :vsModel.sync="settings.intra_community_cif"/>
                <BCol cols="3" >
                  <label>Certificado</label>
                  <BFormFile @change="onFileUpload" accept=".p12, .pem, .pfx, .cer, .crt" placeholder="Elige un archivo..." drop-placeholder="Suéltalo aquí..." />
                </BCol>
                <BCol cols="3" v-if="settings.existsCert" class="d-flex align-items-baseline mt-2">
                  <p>Existe un certificado</p>
                  <BButton variant="flat-danger" class="btn-icon" @click="deletePopupAxios(null, `settings/delete-cert`)">
                    <FeatherIcon size="18" icon="TrashIcon" />
                  </BButton>
                </BCol>
                <TextareaValidated class="mt-2" vsMd="12" vsName="Información del Registro Mercantil" vsLabel="name" :vsModel.sync="settings.commercial_registry_info"/>
              </BRow>
              <BRow v-if="!settings.is_company">
                <CheckboxValidated vsName="" class="pt-1" :vsModel.sync="hasWithholding" vsMd="6" :vsLabel="$t('Withholding')" />
                <div v-show="hasWithholding" style="width:100%">
                  <VSelectValidated  vsName="IRPF" :vsModel.sync="settings.pit_id" :vsReduce="pit => pit.id" :vsOptions="pits" vsLabel="name" :vsClearable="true"/>
                </div>
              </BRow>

              <!-- submit and reset -->
              <BRow>
                <BCol cols="12" class="mt-2">
                  <BButton type="submit" variant="primary" class="mr-1" @click="updateBillingData"> {{ $t('Submit') }} </BButton>
                  <BButton type="reset" variant="outline-secondary" > {{ $t('Reset') }} </BButton>
                </BCol>
              </BRow>
            </ValidationObserver>

          </BForm>

      </BCard>

      <BCard>
            <BRow>
                <BCol md="4">
                    <div class="logo-container my-2 text-center d-flex justify-content-center border rounded">
                        <BImg fluid :src="previewSquareLogo ? previewSquareLogo : settings.square_logo" />
                    </div>
                    <span class="pb-1"><small>Logo cuadrado</small></span>
                    <BFormFile v-model="settings.square_logo" accept="image/*" @change="onSquareLogoChange" />
                </BCol>
                <BCol md="4">
                    <div class="logo-container my-2 text-center d-flex justify-content-center border rounded">
                        <BImg fluid :src="previewFullLogo ? previewFullLogo : settings.full_logo" />
                    </div>
                    <span class="pb-1"><small>Logo completo</small></span>
                    <BFormFile v-model="settings.full_logo" accept="image/*" @change="onFullLogoChange" />
                </BCol>
                <BCol md="4">
                    <div class="logo-container my-2 text-center d-flex justify-content-center border rounded">
                        <BImg fluid :src="previewFavicon ?  previewFavicon : settings.favicon" />
                    </div>
                    <span class="pb-1"><small>Favicon</small></span>
                    <BFormFile v-model="settings.favicon" accept="image/*" @change="onFaviconChange" />
                </BCol>
            </BRow>
        </BCard>


        <!-- Políticas -->
        <BCard>
            <BRow>
                <BCol md="4"> <TextInputValidated class="p-0 my-1" vsName="Política de privacidad (URL)" :vsModel.sync="settings.privacy_policy_url" vsLabel="privacy_policy_url" /> </BCol>
                <BCol md="4"> <TextInputValidated class="p-0 my-1" vsName="Política de cookies (URL)" :vsModel.sync="settings.cookies_url" vsLabel="cookies_url" /> </BCol>
                <BCol md="4"> <TextInputValidated class="p-0 my-1" vsName="Aviso legal (URL)" :vsModel.sync="settings.legal_url" vsLabel="legal_url" /> </BCol>
                <BCol> <BButton @click="onSubmit()" variant="primary">Actualizar</BButton> </BCol>
            </BRow>
        </BCard>

        <BCard>
          <BForm @submit.prevent>
            <BRow>

              <!-- public register -->
              <BCol cols="12">
                <BFormCheckbox name="check-button" v-model="settings.public_register" switch inline> {{ $t('Enable public register') }} </BFormCheckbox>
              </BCol>

              <BCol class="mt-2">
                <BFormCheckbox name="check-autoregister-button" v-model="settings.clients_auto_register"  switch inline> {{ $t('Enable students autoregister') }} </BFormCheckbox>
              </BCol>

              <!-- submit and reset -->
              <BCol cols="12" class="mt-3">
                <BButton type="submit" variant="primary" class="mr-1" @click="onSubmit"> {{ $t('Submit') }} </BButton>
                <BButton type="reset" variant="outline-secondary" > {{ $t('Reset') }} </BButton>
              </BCol>

            </BRow>
          </BForm>
        </BCard>


        <BModal ref="credentialsModal" hide-footer centered title="Introduce tu contraseña">
          <small>Si subes otro certificado y ya tienes otro subido el anterior se borrará</small>  
          <ValidationObserver ref="credentialsForm" #default="{invalid}" >
            <!-- @submit.prevent="login" -->
            <BForm class="auth-login-form mt-1"  >
              <!-- forgot password -->
              <BFormGroup>
                <div class="d-flex justify-content-between">
                  <label for="login-password">{{ $t("Password") }}</label>
                </div>
                <ValidationProvider #default="{ errors }" :name="$t('password')" vid="password" rules="required" >
                  <BInputGroup class="inputGroup-merge" :class="errors.length > 0 ? 'is-invalid':null" >
                    <BFormInput id="" v-model="user_password" :state="errors.length > 0 ? false:null" class="form-control-merge" type="password" name="" :placeholder=" $t('Password')" />
                  </BInputGroup>
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </BFormGroup>

              <!-- submit buttons -->
              <BButton  variant="primary" block @click.prevent="saveCert"> Aceptar </BButton>
            </BForm>
          </ValidationObserver>
        </BModal>

    </div>
</template>
<script>
import { BButton, BCard, BCol, BFormFile, BImg, BRow, BFormRadio, BFormRadioGroup, BForm, BFormGroup, BInputGroup, BFormInput, BFormCheckbox } from 'bootstrap-vue'
import { updateSettings, uploadLogos } from '@/composables/settingsService'
import { inject, ref } from '@vue/composition-api'
import { ALLOWED_IMAGE_TYPES } from "@/utils/constants"
import TextInputValidated from '@/components/forms/TextInputValidated.vue'
import popups from '@/hooks/popups'
import VSelectValidated from '@/components/forms/vSelectValidated.vue'
import CheckboxValidated from '@/components/forms/CheckboxValidated.vue'
import TextareaValidated from '@/components/forms/TextareaValidated.vue'
import { getCountries, getProvinces, uploadCert } from '@/composables/settingsService'
import store from '@/store'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: { BCard, BRow, BCol, TextInputValidated, BButton, BImg, BFormFile, BFormRadio, BFormRadioGroup, VSelectValidated, CheckboxValidated, TextareaValidated, ValidationProvider, ValidationObserver, BForm, BFormGroup, BInputGroup, BFormInput, BFormCheckbox },
  emits: ['refetchData'],
  setup(props, {emit}){
    const { successToast, errorToast, deletePopupAxios } = popups()
    const pits = inject('pits')
    const previewSquareLogo = ref(null)
    const previewFullLogo = ref(null)
    const previewFavicon = ref(null)
    const settings = inject('settings')
    const credentialsModal = ref(null)
    const file = ref(null)
    const user_password=ref(null)

    const institutionsOptions = [
        { text: 'Empresa', value: true},
        { text: 'Autónomo/a', value: false},
    ]
    const hasWithholding = ref(false)
    hasWithholding.value = settings.value.pit != null ? true : false
    const countries = ref([])
    const provinces = ref([])
    const fetchCountries = async function() { countries.value = await getCountries() }
    const fetchProvinces = async function() { provinces.value = await getProvinces() }
    fetchCountries()
    fetchProvinces() 

    const refetchData = () => {
      emit('refetch-data')
    }

    /**
     * Enviar formulario de actualización de ajustes
     */
    const onSubmit = async function() {
        const res = await updateSettings(settings.value)
        if(res.success) {
            successToast('Actualizados ajustes de la aplicación')
        } else {
            errorToast('No se han podido actualizar los ajustes de la aplicación')
        }
    }

      /**
       * Actualizar datos de facturación
       */
       const updateBillingData = function(){
        if (hasWithholding.value && !settings.value.pit_id) {
          errorToast("Añade un IRPF");
          return
        }

        if (!hasWithholding.value) {
          settings.value.pit = null
        }

        onSubmit()
      }

    /**
     * Actualizar la imagen de formato cuadrado
     * @param {Event} evt 
     */
    const onSquareLogoChange = async function(evt) { 
        try {            
            let file = evt.target.files[0]

            // Si el archivo está dentro de los formatos admitidos
            if(!ALLOWED_IMAGE_TYPES.includes(file["type"])) {
                previewSquareLogo.value = null
                errorToast("Tipo de imagen inválido")
                return
            }

            previewSquareLogo.value = URL.createObjectURL(file) 
            let res = await uploadLogos(file, "square")
            if(res.success) {
                successToast("Imagen actualizada")
            } else {
                previewSquareLogo.value = null
                errorToast("No se ha podido actualizar la imagen")
            }
        } catch (error) {
            previewSquareLogo.value = null
            errorToast(error)
        }
    }

    /**
     * Actualizar la firma
     * @param {Event} evt 
     */
    const onFileUpload = (event) => {
        credentialsModal.value.show()
        if (event.target.files) {
          file.value = event.target.files[0]
        } else {
          file.value = event.dataTransfer.files[0]
        }
      }

    const saveCert = async function () {
    let response = await uploadCert(file.value, user_password.value)
    if (response.success) {
        successToast("Certificado subido correctamente")
        file.value = null
        user_password.value = null
        refetchData()
        credentialsModal.value.hide()

    } else {
        if (response.msg=="INCORRECT_PASSWORD") {
          errorToast("Contraseña incorrecta")
        } else if (response.msg=="INVALID_EXTENSION") {
          errorToast("Extensión del certificado inválida")
        } else {
        errorToast("Error subiendo certificado")
        }
    }
    }


    /**
     * Actualizar el logo completo
     * @param {Event} evt 
     */
    const onFullLogoChange = async function(evt) { 
        try {
            let file = evt.target.files[0]

            // Si el archivo está dentro de los formatos admitidos
            if (!ALLOWED_IMAGE_TYPES.includes(file["type"])) {
                previewFullLogo.value = null
                errorToast("Tipo de imagen inválido")
            }

            previewFullLogo.value = URL.createObjectURL(file) 
            let res = await uploadLogos(file, "full")
            if (res.success) {
                successToast("Imagen actualizada")
            } else {
                previewFullLogo.value = null
                errorToast("No se ha podido actualizar la imagen")
            }
        } catch (error) {
            previewFullLogo.value = null
            errorToast(error)
        }
    }

    /**
     * Actualiza el favicon
     * @param {Event} evt 
     */
    const onFaviconChange = async function(evt) { 
        try {
            let file = evt.target.files[0]

            // Si el archivo está dentro de los formatos admitidos
            if (!ALLOWED_IMAGE_TYPES.includes(file["type"])) {
                previewFavicon.value = null
                errorToast("Tipo de imagen inválido")
            }

            previewFavicon.value = URL.createObjectURL(file) 
            let res = await uploadLogos(file, "favicon")
            if (res.success) {
                successToast("Imagen actualizada")
            } else {
                previewFavicon.value = null
                errorToast("No se ha podido actualizar la imagen")
            }
        } catch (error) {
            previewFavicon.value = null
            errorToast(error)
        }
    }


    return { 
        previewSquareLogo,
        previewFullLogo,
        previewFavicon,
        settings,
        institutionsOptions,

        onSquareLogoChange,
        onFullLogoChange,
        onFaviconChange,
        onSubmit,
        updateBillingData,
        countries,
        provinces,
        hasWithholding,
        onFileUpload,
        pits,
        credentialsModal,
        saveCert,
        user_password,
        deletePopupAxios,
        refetchData
    }
  },

}
</script>
<style lang="scss" scoped>
    .custom-file-input ~ .custom-file-label::after {
        content: 'Seleccionar';
    }

    .logo-container {
        // min-height: 300px;
        // max-height: 300px;
        height: 300px;
    }
</style>